import React from 'react';
import { Link } from 'react-router-dom';
import './SubServiceTemplate.css';

const SubServiceTemplate = ({
    category,
    title,
    description,
    heroImage,
    features,
    benefits,
    process,
    relatedServices,
    ctaText,
    ctaLink,
    parentLink,
    parentTitle
}) => {
    return (
        <div className="sub-service-page">
            {/* Breadcrumb */}
            <div className="breadcrumb-container">
                <div className="container">
                    <div className="breadcrumb">
                        <Link to="/">Home</Link>
                        <span>/</span>
                        <Link to="/services">Services</Link>
                        <span>/</span>
                        <Link to={parentLink}>{parentTitle}</Link>
                        <span>/</span>
                        <span>{title}</span>
                    </div>
                </div>
            </div>

            {/* Hero Section */}
            <section className="sub-service-hero">
                <div className="container">
                    <div className="sub-service-hero-wrapper">
                        <div className="sub-service-hero-content">
                            <div className="label">{category}</div>
                            <h1>{title}</h1>
                            <p>{description}</p>
                        </div>
                        {/* Service Image */}
                        <div className="sub-service-hero-visual">
                            {heroImage ? (
                                <img src={heroImage} alt={title} className="sub-service-hero-image" />
                            ) : (
                                <div className="sub-service-hero-image-placeholder">
                                    <p>🖼️ Add Service Image</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </section>

            {/* Features Section */}
            <section className="sub-service-features">
                <div className="container">
                    <h2>What's Included</h2>
                    <div className="features-grid">
                        {features.map((feature, index) => (
                            <div className="feature-item" key={index}>
                                <div className="feature-icon">{feature.icon || '✓'}</div>
                                <div>
                                    <h3>{feature.title}</h3>
                                    <p>{feature.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Benefits Section */}
            <section className="sub-service-benefits">
                <div className="container">
                    <h2>Key Benefits</h2>
                    <div className="benefits-grid">
                        {benefits.map((benefit, index) => {
                            // Default icons if not provided
                            const defaultIcons = ['🎯', '📈', '✨', '💡', '🚀', '⭐'];
                            const icon = benefit.icon || defaultIcons[index % defaultIcons.length];

                            return (
                                <div className="benefit-card" key={index}>
                                    <div className="benefit-icon">{icon}</div>
                                    <h3>{benefit.title}</h3>
                                    <p>{benefit.description}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

            {/* Process Section */}
            {process && process.length > 0 && (
                <section className="sub-service-process">
                    <div className="container">
                        <h2>Our Process</h2>
                        <div className="process-timeline">
                            {process.map((step, index) => (
                                <div className="process-item" key={index}>
                                    <div className="process-number">{String(index + 1).padStart(2, '0')}</div>
                                    <h3>{step.title}</h3>
                                    <p>{step.description}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            )}

            {/* Related Services */}
            {relatedServices && relatedServices.length > 0 && (
                <section className="related-services">
                    <div className="container">
                        <h2>Related Services</h2>
                        <div className="related-grid">
                            {relatedServices.map((service, index) => (
                                <Link to={service.link} key={index} className="related-card">
                                    <h3>{service.title}</h3>
                                    <p>{service.description}</p>
                                    <span className="view-service">View Service →</span>
                                </Link>
                            ))}
                        </div>
                    </div>
                </section>
            )}

            {/* CTA Section */}
            <section className="sub-service-cta">
                <div className="container">
                    <h2>Ready to Get Started?</h2>
                    <p>{ctaText}</p>
                    <Link to={ctaLink} className="btn btn-primary">
                        Book a Free Consultation
                        <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                        </svg>
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default SubServiceTemplate;
